import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AnnouncementsStorage } from './announcements-storage';
import { Announcement } from './announcement';
import { Observable } from 'rxjs';
import { MdlDialogService, IMdlCustomDialogConfiguration } from '@angular-mdl/core';
import { AnnouncementDialogComponent, ANNOUNCEMENT_TOKEN } from './announcement-dialog.component';

@Component({
    selector: 'announcements',
    template: require('./announcements.component.html'),
    styles: [require('./announcements.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AnnouncementsComponent implements OnInit {
    public announcements: Observable<Announcement[]>;

    constructor(
        private announcementsStorage: AnnouncementsStorage,
        private dialogServce: MdlDialogService
    ) { }

    public ngOnInit() {
        this.announcements = this.announcementsStorage.all;
    }

    public openDialog( announcement: Announcement) {
        const configDialog: IMdlCustomDialogConfiguration = {
            component: AnnouncementDialogComponent,
            providers: [{
                provide: ANNOUNCEMENT_TOKEN, useValue: announcement
            }],
            isModal: true,
            clickOutsideToClose: true,
            classes: 'scrollable'
        };

        this.dialogServce.showCustomDialog(configDialog);
    }
}